import React from "react";

/**
 * Readal Systems icon mark only (no wordmark) — for tight spaces
 * like a navbar or footer brand row, sitting next to plain text.
 *
 * Usage:
 *   <ReadalMark />
 *   <ReadalMark size={36} />
 */
export default function ReadalMark({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-64 -64 128 128"
      role="img"
      aria-label="Readal Systems icon"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="0"
        cy="0"
        r="56"
        fill="none"
        stroke="#0EA5E9"
        strokeWidth="1.5"
        strokeDasharray="10 6"
        opacity="0.35"
      />

      <polygon
        points="0,-32 28,0 0,32 -28,0"
        fill="none"
        stroke="#0EA5E9"
        strokeWidth="1.8"
        opacity="0.7"
      />

      <polygon points="0,-16 14,0 0,16 -14,0" fill="#0EA5E9" opacity="0.9" />

      <circle cx="0" cy="-56" r="4.5" fill="#0EA5E9" opacity="0.9" />
      <circle cx="56" cy="0" r="4.5" fill="#0EA5E9" opacity="0.9" />
      <circle cx="0" cy="56" r="4.5" fill="#0EA5E9" opacity="0.9" />
      <circle cx="-56" cy="0" r="4.5" fill="#0EA5E9" opacity="0.9" />

      <line x1="0" y1="-56" x2="0" y2="-16" stroke="#0EA5E9" strokeWidth="1.5" opacity="0.6" />
      <line x1="56" y1="0" x2="14" y2="0" stroke="#0EA5E9" strokeWidth="1.5" opacity="0.6" />
      <line x1="0" y1="56" x2="0" y2="16" stroke="#0EA5E9" strokeWidth="1.5" opacity="0.6" />
      <line x1="-56" y1="0" x2="-14" y2="0" stroke="#0EA5E9" strokeWidth="1.5" opacity="0.6" />

      <line x1="-28" y1="0" x2="-56" y2="0" stroke="#0EA5E9" strokeWidth="1" opacity="0.4" />
      <line x1="28" y1="0" x2="56" y2="0" stroke="#0EA5E9" strokeWidth="1" opacity="0.4" />
      <line x1="0" y1="-32" x2="0" y2="-56" stroke="#0EA5E9" strokeWidth="1" opacity="0.4" />
      <line x1="0" y1="32" x2="0" y2="56" stroke="#0EA5E9" strokeWidth="1" opacity="0.4" />

      <path
        d="M 22 -22 A 31 31 0 0 1 40 0"
        fill="none"
        stroke="#38BDF8"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.85"
      />
      <path
        d="M -22 22 A 31 31 0 0 1 -40 0"
        fill="none"
        stroke="#38BDF8"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.85"
      />
    </svg>
  );
}